export default "__VITE_ASSET__BDr8QjJ0__"